import * as yup from 'yup';
import { SlideDownMenuLink } from '@web/molecules';
import { schema as slideDownCardSchema } from './slide_down_card';

export const component = SlideDownMenuLink;

export const schema = yup
  .object({
    header: yup.string().required(),
    headerBackgroundColor: yup.string(),
    headerFontColor: yup.string(),
    categories: yup.array(slideDownCardSchema).required(),
  })
  .transform(value => ({
    header: value.header,
    headerBackgroundColor: value.header_background_color || undefined,
    headerFontColor: value.header_font_color || undefined,
    categories: value.categories,
    component: 'slide_down_menu_link',
  }));
